var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},_vm._l((_vm.array),function(ref){
var title = ref.title;
var link = ref.link;
return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:(_vm.scrollTo(("#" + (_vm.$t(link))))),expression:"scrollTo(`#${$t(link)}`)"}],key:link,staticClass:"size-table__shoes__find-size",attrs:{"href":"#"}},[_c('common-text',[_vm._v(_vm._s(title))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }